import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Opts, QueryParams } from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";

type UploadTokenResponse = {
  sasUri: string;
  timestampedFileName: string;
}

export class SasTokenService extends BaseRemoteService {
  public async get(params: QueryParams, opts: Opts): Promise<UploadTokenResponse> {
    const url = `${this.apiRoot}/dataportal/getsasforfile${paramsToSearchString(
      params
    )}`;
    return await super.getRequest<UploadTokenResponse>(url, opts);
  }

  public async getRecentReturn(params: QueryParams, opts: Opts): Promise<string> {
    const url = `${this.apiRoot}/dataportal/getsasforrecentupload${paramsToSearchString(
      params
    )}`;
    return await super.getRequest<string>(url, opts);
  }
}
